import { render, staticRenderFns } from "./ControlPlant.vue?vue&type=template&id=00b35f51&scoped=true&"
import script from "./ControlPlant.vue?vue&type=script&lang=js&"
export * from "./ControlPlant.vue?vue&type=script&lang=js&"
import style0 from "./ControlPlant.vue?vue&type=style&index=0&id=00b35f51&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b35f51",
  null
  
)

export default component.exports